<template>
    <section class="c-faq">
        <y-loading
            v-if="!faqData"
            :active="$wait.is('loading-faq-mvp')"
            size="60"
            height="467px"
            position="relative"
        />
        <div
            v-else
            class="c-faq--loaded"
        >
            <div class="c-faq__title">
                <component
                    :is="actualTitleTag || 'h3'"
                    v-text="actualTitleText || $t('mvp.faq_title')"
                />
            </div>
            <y-faq-accordion
                v-for="(item, i) in faqData[0].children"
                :key="item.id"
                :title-tag="titleTag"
                :number="i"
                :item="item"
            />
        </div>
    </section>
</template>

<script >
    import YFaqAccordion from '@/components/FaqAccordion/Index.vue';

    export default {
        name: 'MVPFaq',

        components: {
            YFaqAccordion,
        },

        props: {
            filterSlug: {
                type   : String,
                default: 'mvp',
            },
            titleTag       : String,
            actualTitleTag : String,
            actualTitleText: String,
        },

        /**
         *
         * @inheritDoc
         */
        data() {
            return {
                faqData: null,
            };
        },

        /**
         *
         * @inheritDoc
         */
        created() {
            this.fetch();
        },

        /**
         *
         * @inheritDoc
         */
        methods: {

            /**
             * Check the Promise.all Request Error
             *
             * @param {Array} req - Responses array
             * @param {index} index - number of response
             * @returns {boolean}
             */
            handleReq(req, index) {
                return req && req[index] && !req[index].isAxiosError;
            },

            /**
             * fetch hero data
             *
             * @returns {Promise}
             */
            fetch() {
                this.$wait.start('loading-faq-mvp');
                const faq = this.$services.ContentThemes.faqList({
                    slug     : 'faq',
                    including: ['id', 'title', 'children', 'slug'],
                    lang     : this.$i18n.locale,

                }).catch((error) => {
                    this.handleError(error);
                });

                return Promise.all([faq])
                    .then((responses) => {
                        if (this.handleReq(responses, 0)) {
                            this.faqData = responses[0].data.results.filter((r) => r.slug === this.filterSlug);
                        }
                    })
                    .catch((error) => {
                        this.handleError(error);
                    })
                    .finally(() => {
                        this.$wait.end('loading-faq-mvp');
                    });
            },
        },
    };

</script>

<style lang="scss" src="./faq.scss"/>
